// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal___sh9B","vertical":"styles_vertical__mFM0R"};